import { getRequest } from './api';
import type { ApiResponse } from './types';

export async function fetchAnonymousBootstrapFlags(): Promise<Record<string, any> | null> {
  try {
    const res = await getRequest<ApiResponse<Record<string, any> | null, 'ldBootstrapFlags'>>(
      'launch-darkly/bootstrap/anonymous',
    );
    return res.data?.ldBootstrapFlags ?? null;
  } catch {
    return null;
  }
}
